import { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SEARCH_INDEX } from "../data/site";

const norm = (s) => s.toLowerCase();

export default function MegaSearch({ onNavigate }) {
    const [q, setQ] = useState("");
    const navigate = useNavigate();
    const query = q.trim();

    const results = useMemo(() => {
        if (query.length < 2) return [];
        const nq = norm(query);
        return SEARCH_INDEX.map((e) => {
            const t = norm(e.title);
            let score = 0;
            if (t.startsWith(nq)) score = 3;
            else if (t.includes(nq)) score = 2;
            else if (e.keywords && norm(e.keywords).includes(nq)) score = 1.5;
            else if (e.excerpt && norm(e.excerpt).includes(nq)) score = 1;
            return { e, score };
        })
            .filter((x) => x.score > 0)
            .sort((a, b) => b.score - a.score)
            .slice(0, 6)
            .map((x) => x.e);
    }, [query]);

    const open = query.length >= 2;

    const go = (path) => {
        onNavigate();
        navigate(path);
    };

    return (
        <div className="relative mt-8 max-w-xs" data-testid="mega-search">
            <label htmlFor="mega-search-input" className="sr-only">
                Search the site
            </label>
            <div className="relative">
                <svg
                    className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-3"
                    viewBox="0 0 16 16"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    aria-hidden="true"
                >
                    <circle cx="7" cy="7" r="4.5" />
                    <path d="M10.5 10.5 14 14" />
                </svg>
                <input
                    id="mega-search-input"
                    type="search"
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" && results[0]) go(results[0].path);
                    }}
                    placeholder="Search — try CAES, Ahaus, leadership…"
                    data-testid="mega-search-input"
                    className="field-input !py-2.5 !pl-11 !text-sm"
                />
            </div>
            {open && (
                <div
                    className="mt-2 border border-line bg-white shadow-[0_20px_40px_rgba(10,24,40,0.10)]"
                    data-testid="mega-search-results"
                >
                    {results.length === 0 ? (
                        <p className="px-5 py-4 text-sm text-ink-3">No results for “{query}”.</p>
                    ) : (
                        <ul className="divide-y divide-line">
                            {results.map((r) => (
                                <li key={r.path + r.title}>
                                    <button
                                        onClick={() => go(r.path)}
                                        data-testid="mega-search-result"
                                        className="group flex w-full items-baseline justify-between gap-4 px-5 py-3.5 text-left transition-colors hover:bg-mist"
                                    >
                                        <span>
                                            <span className="block font-display text-sm font-semibold text-ink transition-colors group-hover:text-blue">
                                                {r.title}
                                            </span>
                                            {r.excerpt && (
                                                <span className="mt-0.5 block text-xs leading-relaxed text-ink-3">
                                                    {r.excerpt}
                                                </span>
                                            )}
                                        </span>
                                        <span className="shrink-0 font-mono text-[9px] uppercase tracking-[0.16em] text-ink-3">
                                            {r.type}
                                        </span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
}
